import styles from "./EventDatePlace.module.scss";
import dateIcon from "../../image/calendar.svg";
import placeIcon from "../../image/marker.svg";
import { EventDatePlaceProps } from "../../../../types/props";

// вспомогательные функции
function sameYMD(a: Date, b: Date) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

function fmtDateLong(d: Date) {
  return d.toLocaleDateString("ru-RU", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

function fmtDateShort(d: Date) {
  return d.toLocaleDateString("ru-RU", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function fmtTime(d: Date) {
  return d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

export const EventDatePlace = ({
  starts_at,
  ends_at,
  place,
}: EventDatePlaceProps) => {
  const { name, address, city } = place;
  const cityText = `${city}${name ? `, ${name}` : ""}`;
  const placeText = address || "";

  const start = starts_at ? new Date(starts_at) : null;
  const end = ends_at ? new Date(ends_at) : null;

  let dateText = "";
  let timeText = "";

  if (start && end && !isNaN(end.getTime())) {
    if (sameYMD(start, end)) {
      // один день
      dateText = fmtDateLong(start);
      timeText = `${fmtTime(start)}–${fmtTime(end)}`;
    } else {
      // несколько дней
      const startPart = `${fmtDateShort(start)}, ${fmtTime(start)}`;
      const endPart = `${fmtDateShort(end)}, ${fmtTime(end)}`;
      dateText = `${startPart} — ${endPart}`;
      timeText = ""; // скрываем вторую строку, чтобы не дублировать
    }
  } else if (start) {
    dateText = fmtDateLong(start);
    timeText = fmtTime(start);
  }

  return (
    <div className={styles.date_and_placeWrapper}>
      <div className={styles.wrapper}>
        <img className={styles.icon} src={dateIcon} alt="Дата" />
        <div className={styles.textWrapper}>
          <span className={styles.dateText}>{dateText}</span>
          {timeText && <span className={styles.timeText}>{timeText}</span>}
        </div>
      </div>
      <div className={styles.wrapper}>
        <img className={styles.icon} src={placeIcon} alt="Место" />
        <div className={styles.textWrapper}>
          <span className={styles.cityText}>{cityText}</span>
          {placeText && <span className={styles.addressText}>{placeText}</span>}
        </div>
      </div>
    </div>
  );
};